<template>
    <div class="WRORobot">
        <h1>WRO世界机器人奥林匹克</h1>
        
        <div class="section" v-for="(content, index) in sections" :key="index" style="white-space: break-spaces;">
            <h2>{{ content.title }}</h2>
            <p v-if="content.body" style="text-align: justify;">&emsp;&emsp;{{ content.body }}</p>
        </div>
        
        <!-- Optional: Include images or illustrations related to the laboratory -->
        
        <div class="section" v-if="hasImages">
            <h2>赛事概览</h2>
            <div class="flex-container">
                <div class="flex-item" v-for="(image, index) in images" :key="index">
                    <img v-loading="{ minHeight: '50px', minWidth: '50px', size: '25px' }" :src="require('../assets/images/WRO/' + image.src)" :alt="image.alt">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        sections: [
            {
                title: 'WRO是什么样的比赛？',
                body: 'WRO（World Robot Olympiad）世界机器人奥林匹克竞赛是全球最具影响力的青少年机器人教育赛事之一，覆盖全球90多个国家和地区。圣七教育作为WRO中国官方合作机构，致力于推广WRO创意赛赛项，为中国青少年提供对接国际标准的机器人项目学习与竞赛机会，激发学生在工程设计、编程思维、团队协作与问题解决等多方面的综合能力。'
            },
            {
                title:'WRO创意赛常见问答 Q&A',
                body: 'Q1: WRO创意赛（未来发明家赛项）是什么？\n  A: WRO创意赛（Future Innovators）是WRO（World Robot Olympiad，世界青少年机器人奥林匹克竞赛）中的一个开放性项目赛项。参赛学生围绕每年设定的全球主题，提出创新解决方案，并使用机器人或智能系统进行创意设计、原型搭建与展示汇报，融合STEM技能与设计思维。\n  \n  Q2: 谁可以参加创意赛？是否需要机器人基础？\n  A: WRO创意赛面向小学高年级至高中阶段学生，分设不同年龄组。参赛者不要求具备完整机器人编程经验，但需要对结构搭建、建模设计或智能电子模块（如Arduino、Micro\:bit等）有一定理解。我们鼓励跨学科的团队合作，融合技术、艺术与商业思维。\n  \n  Q3: 参赛需要准备哪些内容？\n  A: 团队需完成以下任务：\n  ✅根据主题提出创意解决方案\n  ✅完成机器人或智能设备原型设计与制作\n  ✅准备项目展示板与演示视频\n  ✅撰写项目说明书，说明设计背景、技术实现与社会意义\n  ✅现场答辩与互动展示\n  \n  Q4: 创意赛和其他WRO项目（如常规赛）有什么区别？\n  A: WRO创意赛强调自主命题与跨领域创意解决方案，不像常规赛那样在统一赛道上解决预设任务。它更像是一个科技创新+机器人”项目展示平台，培养学生的问题解决能力、设计思维、表达与展示能力。\n  \n  Q5: 比赛使用的设备和材料有限制吗？\n  A: 创意赛鼓励开放性设计，主控平台不限，常见选项包括LEGO、Arduino、Micro\:bit、Raspberry Pi、3D打印结构件等，允许使用多种感应器、电机、LED、屏幕等模块，前提是作品必须具有可动性或智能控制功能。\n  \n  Q6: 评审标准有哪些？\n  A: 评审将综合考量以下几点：\n  • 创意性与现实相关性\n  • 技术实现与结构设计\n  • 示效果与沟通表达能力\n  • 团队合作与项目管理\n  \n  Q7: 比赛语言和展示形式要求是什么？\n  A: 多数地区比赛使用中文或英文，国际赛采用英文展示。团队需准备展板（一般为三折板或A1/A0尺寸）、视频演示和现场讲解，有些赛区还要求书面报告或商业方案文档。\n  \n  Q8: 参赛有什么收获？\n  A: 可以获得以下收获：\n  • 获得国际认、证书与奖杯\n  • 项目可申请CREST AWARDS（ 英国科学协会管理的英国全国性教育计划, 英国唯一一个国家认可的 STEM 学科学生主导项目工作计划，为跨学科项目提供权威评估标准）\n  • 背景提升：优秀作品可作为升学Portfolio的一部分\n  • 专业技能：提升工程设计、沟通表达与团队协作能力\n  • 申请专利机会：WRO每年的赛题源于联合国可持续发展目标，优秀作品有机会申请项目专利',
            },
        ],
        //Images array can be added here if available
        images: [
            { src: "0.jpg", alt: 'WRO赛事赛场剪影1' },
            { src: "1.jpg", alt: 'WRO赛事赛场剪影2' },
            { src: "2.jpg", alt: 'WRO赛事赛场剪影3' },
            { src: "3.jpg", alt: 'WRO赛事赛场剪影4' },
            { src: "4.jpg", alt: 'WRO赛事赛场剪影5' },
            { src: "5.jpg", alt: 'WRO赛事赛场剪影6' },
        ],
        hasImages: true, // Set to true if images array is defined
        };
    },
};
</script>

<style scoped>
/* Add basic styling for readability */
.WRORobot {
    padding: 6vw;
    font-family: 'FangYuan';
    color: #513890;
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: 0.16em;
    line-height: 2em;
}

body {
    line-height: 1.6;
    margin: 0;
    padding: 0;
}

h1 {
    text-align: center;
    margin-top: 3rem;
}

.section {
    margin-bottom: 2rem;
}

h2 {
    margin-top: 2rem;
}

ul {
    display: flex;
    list-style-type: disc;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
}

ul li{
    display: inline;
    flex: 1;
    text-align: left;
}

p {
    margin-bottom: 1rem;
}

.highlight {
    font-weight: bold;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 1rem;
}

.flex-item {
    flex-basis: calc(50% - 1rem);
    margin-bottom: 1rem;
}

img {
    max-width: 100%;
    height: auto;
}

@media screen and (max-width: 768px) {
    .flex-item {
        flex-basis: 100%;
    }
}
</style>